import { render } from "./AppFooterNarrow.vue?vue&type=template&id=51dbf21a"
import script from "./AppFooterNarrow.vue?vue&type=script&lang=js"
export * from "./AppFooterNarrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__